import { ChartSeries } from 'components/Charts/types';

/**
 * Transforms MOIC series data to include per-bar colors and styling
 * Each bar will have gradient colors and shadow effects
 */
export const transformMoicSeries = (series: ChartSeries[]) =>
  series.map(s => {
    // Format data to support per-bar animations and colors
    // ECharts supports data as objects with value and itemStyle
    const dataWithAnimation = s.data.map(point => {
      const colors = (point.metadata?.colors as { base: string; darker: string } | undefined) || {
        base: '#9b59b6',
        darker: '#8e44ad',
      };
      const baseColor = colors.base;
      const darkerColor = colors.darker;
      const shadowColor = baseColor.replace('rgb(', 'rgba(').replace(')', ', 0.5)');

      return {
        value: point.y,
        // Each bar can have its own animation delay
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: baseColor,
              },
              {
                offset: 1,
                color: darkerColor,
              },
            ],
          },
          borderRadius: [8, 8, 0, 0],
          shadowBlur: 10,
          shadowColor,
          shadowOffsetY: 4,
        },
      };
    });

    return {
      name: s.label,
      type: 'bar',
      data: dataWithAnimation,
      barWidth: '60%',
      emphasis: {
        itemStyle: {
          shadowBlur: 15,
          shadowOffsetY: 6,
        },
      },
    };
  });
